<template>
  <div ref="builderpage">
    <dialogue-sidebar :isSidebarActive="dialogueSidebar"
                      :nodeSelected="selectedNode"
                      :buttoncaption="caption"
                      :sidebarHeader="sbarHeader"
                      @saveData="dataSaved"
                      @closeSidebar="dialogueSidebar = false"
                      :gotoList="allGotos"
                      :moduleId="moduleId"
                      :courseId="courseId"
                      :sourceTaskId="sourceTaskId"
                      :taskTypeList="taskTypeList"
                      :taskClassificationTypes="taskClassificationTypes" />

    <video-sidebar :isSidebarActive="videoSidebar"
                  :nodeSelected="selectedNode"
                  :buttoncaption="caption"
                  :sidebarHeader="sbarHeader"
                  @saveData="dataSaved"
                  @closeSidebar="videoSidebar = false"
                  :courseId="courseId"
                  :gotoList="allGotos"
                  :moduleId="moduleId"
                  :sourceTaskId="sourceTaskId"
                  :taskTypeList="taskTypeList"
                  :taskClassificationTypes="taskClassificationTypes" />

    <i-spring-quiz-sidebar :isSidebarActive="iSpringQuizSidebar"
                          :nodeSelected="selectedNode"
                          :buttoncaption="caption"
                          :sidebarHeader="sbarHeader"
                          @saveData="dataSaved"
                          @closeSidebar="iSpringQuizSidebar = false"
                          :gotoList="allGotos"
                          :courseId="courseId"
                          :moduleId="moduleId"
                          :sourceTaskId="sourceTaskId"
                          :taskTypeList="taskTypeList"
                          :taskClassificationTypes="taskClassificationTypes" />

    <presentation-sidebar :isSidebarActive="presentationSidebar"
                          :nodeSelected="selectedNode"
                          :buttoncaption="caption"
                          :sidebarHeader="sbarHeader"
                          @saveData="dataSaved"
                          @closeSidebar="presentationSidebar = false"
                          :gotoList="allGotos"
                          :courseId="courseId"
                          :moduleId="moduleId"
                          :sourceTaskId="sourceTaskId"
                          :taskTypeList="taskTypeList"
                          :taskClassificationTypes="taskClassificationTypes" />

    <document-sidebar :isSidebarActive="documentSidebar"
                      :nodeSelected="selectedNode"
                      :buttoncaption="caption"
                      :sidebarHeader="sbarHeader"
                      @saveData="dataSaved"
                      @closeSidebar="documentSidebar = false"
                      :courseId="courseId"
                      :gotoList="allGotos"
                      :moduleId="moduleId"
                      :sourceTaskId="sourceTaskId"
                      :taskTypeList="taskTypeList"
                      :taskClassificationTypes="taskClassificationTypes" />

    <upload-sidebar :isSidebarActive="uploadSidebar"
                    :nodeSelected="selectedNode"
                    :buttoncaption="caption"
                    :sidebarHeader="sbarHeader"
                    @saveData="dataSaved"
                    @closeSidebar="uploadSidebar = false"
                    :gotoList="allGotos"
                    :courseId="courseId"
                    :moduleId="moduleId"
                    :sourceTaskId="sourceTaskId"
                    :taskTypeList="taskTypeList"
                    :taskClassificationTypes="taskClassificationTypes" />

    <navigation-sidebar :isSidebarActive="navigationSidebar"
                        :nodeSelected="selectedNode"
                        :buttoncaption="caption"
                        :sidebarHeader="sbarHeader"
                        @saveData="dataSaved"
                        @closeSidebar="navigationSidebar = false"
                        :courseId="courseId"
                        :moduleId="moduleId"
                        :sourceTaskId="sourceTaskId"
                        :taskTypeList="taskTypeList"
                        :taskClassificationTypes="taskClassificationTypes" />

    <videoCapture-sidebar :isSidebarActive="videoCaptureSidebar"
                    :nodeSelected="selectedNode"
                    :buttoncaption="caption"
                    :sidebarHeader="sbarHeader"
                    @saveData="dataSaved"
                    @closeSidebar="videoCaptureSidebar = false"
                    :gotoList="allGotos"
                    :courseId="courseId"
                    :moduleId="moduleId"
                    :sourceTaskId="sourceTaskId"
                    :taskTypeList="taskTypeList"
                    :taskClassificationTypes="taskClassificationTypes" />

    <quiz-sidebar  :isSidebarActive="quizSidebar"
                            :nodeSelected="selectedNode"
                            :buttoncaption="caption"
                            :sidebarHeader="sbarHeader"
                            @saveData="dataSaved"
                            @closeSidebar="quizSidebar = false"
                            :gotoList="allGotos"
                            :courseId="courseId"
                            :moduleId="moduleId"
                            :sourceTaskId="sourceTaskId"
                            :taskTypeList="taskTypeList"
                            :taskClassificationTypes="taskClassificationTypes" />

    <text-navigation-sidebar :isSidebarActive="textNavigationSidebar"
                      :nodeSelected="selectedNode"
                      :buttoncaption="caption"
                      :sidebarHeader="sbarHeader"
                      @saveData="dataSaved"
                      @closeSidebar="textNavigationSidebar = false"
                      :gotoList="allGotos"
                      :courseId="courseId"
                      :moduleId="moduleId"
                      :sourceTaskId="sourceTaskId"
                      :taskTypeList="taskTypeList"
                      :taskClassificationTypes="taskClassificationTypes" />

    <podcast-sidebar :isSidebarActive="podcastSidebar"
                  :nodeSelected="selectedNode"
                  :buttoncaption="caption"
                  :sidebarHeader="sbarHeader"
                  @saveData="dataSaved"
                  @closeSidebar="podcastSidebar = false"
                  :gotoList="allGotos"
                  :courseId="courseId"
                  :moduleId="moduleId"
                  :sourceTaskId="sourceTaskId"
                  :taskTypeList="taskTypeList"
                  :taskClassificationTypes="taskClassificationTypes" />

    <video-quiz-sidebar :isSidebarActive="videoQuizSidebar"
                    :nodeSelected="selectedNode"
                    :buttoncaption="caption"
                    :sidebarHeader="sbarHeader"
                    @saveData="dataSaved"
                    :courseId="courseId"
                    @closeSidebar="videoQuizSidebar = false"
                    :gotoList="allGotos"
                    :moduleId="moduleId"
                    :sourceTaskId="sourceTaskId"
                    :taskTypeList="taskTypeList"
                    :taskClassificationTypes="taskClassificationTypes" />


    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <div class="flex flex-wrap-reverse items-center">
        <!-- <vs-button :to="{ name: 'BrowseContent', params: { selectedData: $route.params.selectedData, navFromBuilder: true } }">Back</vs-button> -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
          <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" v-scroll-to="{el: '#sceneLabel', container: '#dialogue-sidebar', duration: 500}">
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-success">Add New Task</span>
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="showDialogueSidebar">
              <span>Dialogue</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showVideoSidebar">
              <span>Video</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showISpringQuizSidebar">
              <span>iSpring Quiz</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showPresentationSidebar">
              <span>Presentation</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showDocumentSidebar">
              <span>Document</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showUploadSidebar">
              <span>Upload</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showNavigationSidebar">
              <span>Navigation Map</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showVideoCaptureSidebar">
              <span>Video Capture</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showQuizSidebar">
              <span>Quiz</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showTextNavigationSidebar">
              <span>Text Navigation</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showPodcastSidebar">
              <span>Podcast</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="showVideoQuizSidebar">
              <span>Video Quiz</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="p-3 mb-8 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-warning border border-solid border-warning" @click="cyReset">
        <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-warning">Re-center Canvas</span>
      </div>
      <div class="p-3 mb-8 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="preview">
        <feather-icon icon="PlayIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary" :numberOfTasks="allGotos">Preview From Start</span>
      </div>
      <div class="p-3 mb-8 flex items-center justify-between">
        <vs-button class="school-primary_gradient" :disabled="!story" radius icon-pack="feather" icon="icon-settings" @click="configure" />
      </div>
    </div>
    <keep-alive>
      <div id="holder" class="w-full">
        <cytoscape ref="cytoscape" class="vs-con-loading__container" :config="config"></cytoscape>
      </div>
    </keep-alive>

    <vs-popup id="configurePopup" ref="configurePopup" title="Configure Settings for the Module" fullscreen class="popup_class" :active.sync="configurePopupActive">
      <div v-if="configurePopupActive">
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <label class="ml-1">Start Task</label>
            <v-select class="w-full style-chooser"
                      placeholder="Search / Select A Start Task"
                      :options="tasks"
                      v-model="startTaskDropdown" />
          </div>
        </div>
        <div class="vx-row mt-3">
          <div class="vx-col w-1/2">
            <label class="ml-1">End Task</label>
            <v-select class="w-full style-chooser"
                      placeholder="Search / Select A End Task"
                      :options="tasks"
                      v-model="endTaskDropdown" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-divider>Milestones</vs-divider>
          </div>
        </div>
        <div>
          <ul>
            <li v-for="(milestone, index) in moduleData.milestones" :key="index">
              <div id="milestones-row" class="vx-row mb-4">
                <div class="vx-col w-1/3">
                  <label>Task</label>
                  <v-select class="w-full style-chooser"
                            placeholder="Search / Select A Task"
                            :options="tasks"
                            v-model="milestone.milestoneTaskDropdown" />
                </div>
                <div class="vx-col w-1/4">
                  <label>Days</label>
                  <vs-input autocomplete="off" color="#52b75d" onClick="this.select();" v-validate="'numeric'" name="Days" v-model="milestone.days" />
                  <span class="text-danger text-sm" v-show="errors.has('Days')">{{ errors.first('Days') }}</span>
                </div>
                
                <div class="vx-col w-1/10">
                  <label>Is Visible</label>
                  <vs-checkbox color="success" v-model="milestone.isVisible" />
                </div>

                <div id="delete-column" class="vx-col w-1/6">
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop="deleteMilestone(index)"></vs-button>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <vs-button ref="choicesAdd" class="w-full cursor-pointer mb-4" type="border" color="success" icon-pack="feather" icon="icon-plus" @click="addMilestones"></vs-button>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-divider></vs-divider>
          </div>
        </div>
        <div v-if="isDigi" class="vx-row pl-4">
          <vx-card ref="completeModuleButton" card-background="#11193f" class="glow-effect_dark fixed-width_languages card__no-padding vs-con-loading__container">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text" style="background-color: #262d4a">
                  <span><feather-icon class="pt-1" icon="CheckIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button :disabled="!moduleData.startTaskId || moduleData.isModuleComplete"
                        size="large"
                        class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                        style="border-radius:0 7px 7px 0"
                        @click="completeModule">
                {{ moduleData.isModuleComplete ? 'Module Completed' : 'Complete Module' }}
              </vs-button>
            </vx-input-group>
          </vx-card>
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vx-card ref="saveModuleButton" card-background="#11193f" class="glow-effect_dark limit-width_short card__no-padding vs-con-loading__container">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text" style="background-color: #262d4a">
                    <span><feather-icon class="pt-1" icon="SaveIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button size="large"
                          class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                          style="border-radius:0 7px 7px 0"
                          @click="saveModule">
                  Save
                </vs-button>
              </vx-input-group>
            </vx-card>
          </div>
        </div>
        <div v-else class="vx-row pl-4">
          <vs-button ref="completeModuleButton"
                    :disabled="!moduleData.startTaskId || moduleData.isModuleComplete"
                    class="vs-con-loading__container"
                    type="filled"
                    color="warning"
                    @click="completeModule">
            {{ moduleData.isModuleComplete ? 'Module Completed' : 'Complete Module' }}
          </vs-button>
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button ref="saveModuleButton"
                      class="w-full vs-con-loading__container"
                      type="border"
                      color="success"
                      @click="saveModule">
              Save
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* eslint-disable */
import klay from "cytoscape-klay";
import dialogueSidebar from "./CourseBuilderDialogueForm.vue";
import videoSidebar from "./CourseBuilderVideoForm.vue";
import iSpringQuizSidebar from "./CourseBuilderISpringQuizForm.vue";
import presentationSidebar from "./CourseBuilderPresentationForm.vue";
import documentSidebar from "./CourseBuilderDocumentForm.vue";
import uploadSidebar from "./CourseBuilderUploadForm.vue";
import navigationSidebar from "./CourseBuilderNavigationForm.vue";
import videoCaptureSidebar from "./CourseBuilderVideoCaptureForm.vue";
import quizSidebar from "./CourseBuilderQuizForm.vue";
import textNavigationSidebar from "./CourseBuilderTextNavigationForm.vue";
import podcastSidebar from "./CourseBuilderPodcastForm.vue";
import videoQuizSidebar from "./CourseBuilderVideoQuizForm.vue";
import color from "../../assets/utils/color";
import { type } from "os";

import vSelect from 'vue-select'

const config = {
  elements: [],
  autounselectify: true,
  boxSelectionEnabled: false,
  style: [
    {
      selector: 'node',
      style: {
        'height': 80,
        'width': 80,
        'shape': 'data(shape)', //ellipse, triangle, rectangle, round-rectangle, bottom-round-rectangle, cut-rectangle, barrel, rhomboid, diamond, pentagon, hexagon, concave-hexagon, heptagon, octagon, star, tag, vee, polygon "selector": "node[points]", "style": {"shape-polygon-points": "data(points)"}
        'background-fit': 'cover',
        'border-color': '#000',
        'border-width': 2,
        'border-opacity': 0.5,
        'content': 'data(id)',
        'font-size': 'data(fontsize)',
        'color': '#000000', //font color
        'text-valign': 'center',
        'text-halign': 'center',
        'text-outline-width': 1,
        'text-outline-color': '#FFFFFF',
        'text-outline-opacity': 1
      }
    },
    {
      selector: 'edge',
      style: {
        'curve-style': 'bezier',
        'width': 6,
        'target-arrow-shape': 'triangle-backcurve',
        // 'target-arrow-shape': 'tee',
        'line-color': '#FF0000',
        'target-arrow-color': '#FF0000'
      }
    },
  ]
};
export default {
  components: {
    dialogueSidebar,
    videoSidebar,
    iSpringQuizSidebar,
    presentationSidebar,
    documentSidebar,
    uploadSidebar,
    navigationSidebar,
    videoCaptureSidebar,
    quizSidebar,
    textNavigationSidebar,
    podcastSidebar,
    videoQuizSidebar,
    'v-select': vSelect
  },
  name: "Builder",
  data() {
    return {
      moduleData: {
        id: 0,
        courseId: 0,
        name: "",
        description: "",
        coinCount: "",
        milestones: [],
        startTaskId: "",
        endTaskId: "",
        isModuleComplete: false,
        price: 0,
        moduleCategoryId: null,
        moduleGroupId: null
      },
      tasks: null,
      startTaskDropdown: 0,
      milestoneTaskDropdown: 0,
      selectedData: null,
      configurePopupActive: false,
      dialogueSidebar: false,
      videoSidebar: false,
      iSpringQuizSidebar: false,
      presentationSidebar: false,
      documentSidebar: false,
      uploadSidebar: false,
      navigationSidebar: false,
      videoCaptureSidebar: false,
      quizSidebar: false,
      textNavigationSidebar: false,
      podcastSidebar: false,
      videoQuizSidebar: false,
      selectedNode: {},
      caption: "",
      sbarHeader: "",
      config,
      selectedId: 0,
      nodeClickedId: 0,
      story: null,
      allGotos: [],
      moduleId: "",
      courseId: "",
      taskClassificationTypes: [],
      sourceTaskId: 0,
      taskTypeList: [
        {text:'Dialogue',value:1},
        {text:'Video',value:2},
        {text:'iSpring Quiz',value:3},
        {text:'Presentation',value:4},
        {text:'Document',value:5},
        {text:'Upload',value:6},
        {text:'Navigation Map',value:7},
        {text:'Video Capture',value:8},
        {text:'Quiz',value:9},
        {text:'Text Navigation',value:10},
        {text:'Podcast',value:11},
        {text:'Video Quiz',value:14}
      ]
    };
  },
  computed: {
    isDigi: function() {
      if(localStorage.getItem("type") == "digi")
        return true;
      else
        return false;
    }
  },
  methods: {
    initSidebar(id, taskTypeId) {
      if (taskTypeId == 1)
        this.dialogueSidebar = true;
      else if (taskTypeId == 2)
        this.videoSidebar = true;
      else if (taskTypeId == 3)
        this.iSpringQuizSidebar = true;
      else if (taskTypeId == 4)
        this.presentationSidebar = true;
      else if (taskTypeId == 5)
        this.documentSidebar = true;
      else if (taskTypeId == 6)
        this.uploadSidebar = true;
      else if (taskTypeId == 7)
        this.navigationSidebar = true;
      else if (taskTypeId == 8)
        this.videoCaptureSidebar = true;
      else if (taskTypeId == 9)
        this.quizSidebar = true;
      else if (taskTypeId == 10)
        this.textNavigationSidebar = true;
      else if (taskTypeId == 11)
        this.podcastSidebar = true;
      else if (taskTypeId == 14)
        this.videoQuizSidebar = true;

      this.selectedNode = {};
      this.caption = "Add";
      this.sbarHeader = "Add Task";

      if(!isNaN(id)){
        this.sourceTaskId = id;
      }
    },
    showDialogueSidebar() {
      this.initSidebar(0, 1);
    },
    showVideoSidebar() {
      this.initSidebar(0, 2);
    },
    showISpringQuizSidebar() {
      this.initSidebar(0, 3);
    },
    showPresentationSidebar() {
      this.initSidebar(0, 4);
    },
    showDocumentSidebar() {
      this.initSidebar(0, 5);
    },
    showUploadSidebar() {
      this.initSidebar(0, 6);
    },
    showNavigationSidebar() {
      this.initSidebar(0, 7);
    },
    showVideoCaptureSidebar() {
      this.initSidebar(0, 8);
    },
    showQuizSidebar() {
      this.initSidebar(0, 9);
    },
    showTextNavigationSidebar() {
      this.initSidebar(0, 10);
    },
    showPodcastSidebar() {
      this.initSidebar(0, 11);
    },
    showVideoQuizSidebar() {
      this.initSidebar(0, 14);
    },
    dataSaved(val, taskTypeId){
      this.dialogueSidebar = false;
      this.videoSidebar = false;
      this.iSpringQuizSidebar = false;
      this.presentationSidebar = false;
      this.documentSidebar = false;
      this.uploadSidebar = false;
      this.navigationSidebar = false;
      this.videoCaptureSidebar = false;
      this.quizSidebar = false;
      this.textNavigationSidebar = false;
      this.podcastSidebar = false;
      this.videoQuizSidebar = false;
      this.showLoadingOnElement("cytoscape", 1, "corners");
      this.loadData();
      if(val) {
        this.initSidebar(val, taskTypeId)
      }
    },
    loadData() {
      const self = this;
      self.moduleId = localStorage.getItem("currentModule");
      self.gettaskClassificationTypes();

      var onSuccess = function (response) {
        self.story = response.data;
        self.courseId = self.story.courseId.toString();
        self.allGotos = self.story.tasks.map(function(item) {
          if (item.name == null || item.name == "")
            return { value: item.id, text: item.displayId }
          else
            return { value: item.id, text: item.displayId + " : " + item.name }
        });
        self.cyUpdate();
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.cytoscape.$el);
      };

      self.$ajaxGet(self, "course/getstory/" + self.moduleId, onSuccess, onFinally);
    },
    nodeClicked(node) {
      var self = this;
      if (node.target.data().taskTypeId == 1) {
        self.dialogueSidebar = true;
      } else if (node.target.data().taskTypeId == 2) {
        self.videoSidebar = true;
      } else if (node.target.data().taskTypeId == 3) {
        self.iSpringQuizSidebar = true;
      } else if (node.target.data().taskTypeId == 4) {
        self.presentationSidebar = true;
      } else if (node.target.data().taskTypeId == 5) {
        self.documentSidebar = true;
      } else if (node.target.data().taskTypeId == 6) {
        self.uploadSidebar = true;
      } else if (node.target.data().taskTypeId == 7) {
        self.navigationSidebar = true;
      } else if (node.target.data().taskTypeId == 8) {
        self.videoCaptureSidebar = true;
      } else if (node.target.data().taskTypeId == 9) {
        self.quizSidebar = true;
      } else if (node.target.data().taskTypeId == 10) {
        self.textNavigationSidebar = true;
      } else if (node.target.data().taskTypeId == 11) {
        self.podcastSidebar = true;
      } else if (node.target.data().taskTypeId == 14) {
        self.videoQuizSidebar = true;
      }
      self.caption = "Update";

      self.selectedId = node.target.id();
      self.nodeClickedId = self.selectedId;
      self.sbarHeader = "Update Task " + self.nodeClickedId;
      self.selectedNode = self.story.tasks.filter(function (item) {
          return item.displayId == self.selectedId;
      })[0];

      self.selectedNode.courseId = self.story.courseId;
    },
    
    preview () {
      if(this.$route.path.includes('digi'))
        window.open('../digi/story?mode=previewStory&moduleId=' + this.moduleId, "_blank");
      else
        window.open('../story?mode=previewStory&moduleId=' + this.moduleId, "_blank");
    },
    cyUpdate () {
      var self = this;
      const cynodes = this.storyElements().nodes;
      const cylinks = this.storyElements().edges;

      var initialPosition = {};

      this.$cytoscape.instance.then(cy => {
        cy.remove(cy.elements())
        cy.add(cynodes)
        cy.add(cylinks)
        cy.layout({
          name: "preset",
          fit: true
        }).run();
        cy.elements()
          .layout({ name: "preset", fit: true })
          .run();
        const that = this;
        cy.nodes().on('vclick', function (node) {
          that.nodeClicked(node)
        });
        cy.nodes().on('cxttapend', function (node) {
          document.oncontextmenu = function(e){
            e.preventDefault();
          }
          if(self.$route.path.includes('digi'))
            window.open('../digi/story?mode=previewStory&moduleId=' + self.moduleId + "&taskDisplayId=" + node.target.data().id, "_blank");
          else
            window.open('../story?mode=previewStory&moduleId=' + self.moduleId + "&taskDisplayId=" + node.target.data().id, "_blank");
        });
        cy.nodes().on('vmousedown', function (node) {
          initialPosition = node.position
        });
        cy.nodes().on('vmouseup', function (node) {
          if(node.position.x != initialPosition.x || node.position.y != initialPosition.y){
            self.updateNodePosition(self.moduleId, node.target.data().id, node.position);
            node.renderedPosition.x = node.position.x;
            node.renderedPosition.y = node.position.y;
          }
        });
        self.cyZoomSettings(cy);
      });
    },
    cyReset () {
      var self = this;

      this.$cytoscape.instance.then(cy => {
        cy.fit();
        self.cyZoomSettings(cy);
      });
    },
    updateNodePosition(moduleId, taskDisplayId, nodePosition) {
      var positionData = {
        moduleId: moduleId,
        taskName: taskDisplayId,
        nodePosition: nodePosition
      }
      this.$ajaxPost(this, "Course/UpdateNodePosition", positionData)
    },
    async afterCreated(cy) {
      var self = this;
      var initialPosition = {};
      self.moduleId = localStorage.getItem("currentModule");

      var onSuccess = function (response) {
        self.story = response.data;
        const  elements  = self.storyElements();
        cy.remove(cy.elements());
        elements.nodes.forEach(n => cy.add(n));
        elements.edges.forEach(n => cy.add(n));
        cy.elements()
          .layout({ name: "preset", fit: true })
          .run();
        cy.nodes().off().on('vclick', function (node) {
          self.nodeClicked(node)
        });
        cy.nodes().on('cxttapend', function (node) {
          document.oncontextmenu = function(e){
            e.preventDefault();
          }
          if(self.$route.path.includes('digi'))
            window.open('../digi/story?mode=previewStory&moduleId=' + self.moduleId + "&taskDisplayId=" + node.target.data().id, "_blank");
          else
            window.open('../story?mode=previewStory&moduleId=' + self.moduleId + "&taskDisplayId=" + node.target.data().id, "_blank");
        });
        cy.nodes().on('vmousedown', function (node) {
          initialPosition = node.position
        });
        cy.nodes().on('vmouseup', function (node) {
          if(node.position.x != initialPosition.x || node.position.y != initialPosition.y){
            self.updateNodePosition(self.moduleId, node.target.data().id, node.position);
            node.renderedPosition.x = node.position.x;
            node.renderedPosition.y = node.position.y;
          }
        });
      };

      self.$ajaxGet(self, "course/getstory/" + self.moduleId, onSuccess);
      self.cyZoomSettings(cy);
    },
    cyZoomSettings(cy) {
      cy.minZoom(1e-1);
      cy.maxZoom(5);
      cy.resize();
      cy.fit();
    },
    storyElements() {
      if(this.story && this.story.tasks){
        var getNodes = this.story.tasks.map(function(item) {
          if(item.dialogTask)
            return { data: { id: item.displayId, taskTypeId: 1, shape: 'ellipse', fontsize: '30px' }, position: {x: item.positionX, y: item.positionY}, css: {'background-color' : '#FFEE58'} };
          else if(item.videoTask)
            return { data: { id: item.displayId, taskTypeId: 2, shape: 'barrel', fontsize: '30px' }, position: {x: item.positionX, y: item.positionY}, css: {'background-color' : '#FFA726'} };
          else if(item.iSpringQuizTask)
            return { data: { id: item.displayId, taskTypeId: 3, shape: 'tag', fontsize: '28px' }, position: {x: item.positionX, y: item.positionY}, css: {'background-color' : '#66BB6A'} };
          else if(item.presentationTask)
            return { data: { id: item.displayId, taskTypeId: 4, shape: 'cut-rectangle', fontsize: '30px' }, position: {x: item.positionX, y: item.positionY}, css: {'background-color' : '#42A5F5'} };
          else if(item.documentTask)
            return { data: { id: item.displayId, taskTypeId: 5, shape: 'diamond', fontsize: '18px' }, position: {x: item.positionX, y: item.positionY}, css: {'background-color' : '#EF5350'} };
          else if(item.uploadTask)
            return { data: { id: item.displayId, taskTypeId: 6, shape: 'concave-hexagon', fontsize: '21px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#EC407A' } };
          else if(item.navigationTask)
            return { data: { id: item.displayId, taskTypeId: 7, shape: 'heptagon', fontsize: '28px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#26C6DA' } };
          else if (item.videoCaptureTask)
            return { data: { id: item.displayId, taskTypeId: 8, shape: 'rhomboid', fontsize: '18px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#26A69A' } };
          else if (item.quizTask)
            return { data: { id: item.displayId, taskTypeId: 9, shape: 'star', fontsize: '22px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#BDBDBD' } };
          else if (item.textNavigationTask)
            return { data: { id: item.displayId, taskTypeId: 10, shape: 'hexagon', fontsize: '26px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#7E57C2' } };
          else if (item.podcastTask)
            return { data: { id: item.displayId, taskTypeId: 11, shape: 'pentagon', fontsize: '26px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#D4E157' } };
          else if (item.videoQuizTask)
            return { data: { id: item.displayId, taskTypeId: 14, shape: 'octagon', fontsize: '24px' }, position: {x: item.positionX, y: item.positionY}, css: { 'background-color': '#FF7CFD' } };
        });

        var directLinks = this.story.tasks.filter(function(item) {
          if(item.dialogTask){
            return item.dialogTask.goTo;
          }
          else if(item.videoTask){
            return item.videoTask.goTo;
          }
          else if(item.presentationTask){
            return item.presentationTask.goTo;
          }
          else if(item.documentTask){
            return item.documentTask.goTo;
          }
          else if(item.uploadTask){
            return item.uploadTask.goTo;
          }
          else if (item.videoCaptureTask)
            return item.videoCaptureTask.goTo;
          else if (item.textNavigationTask)
            return item.textNavigationTask.goTo;
          else if(item.podcastTask){
            return item.podcastTask.goTo;
          }
          else if(item.videoQuizTask){
            return item.videoQuizTask.goTo;
          }
        });

        var getEdges = directLinks.map(function(item) {
          if(item.dialogTask){
            return {
              data: {
                id: item.displayId + "_" + item.dialogTask.goTo,
                source: item.displayId,
                target: item.dialogTask.goTo
              }
            };
          }
          else if(item.videoTask){
            return {
              data: {
                id: item.displayId + "_" + item.videoTask.goTo,
                source: item.displayId,
                target: item.videoTask.goTo
              }
            };
          }
          else if(item.presentationTask){
            return {
              data: {
                id: item.displayId + "_" + item.presentationTask.goTo,
                source: item.displayId,
                target: item.presentationTask.goTo
              }
            };
          }
          else if(item.documentTask){
            return {
              data: {
                id: item.displayId + "_" + item.documentTask.goTo,
                source: item.displayId,
                target: item.documentTask.goTo
              }
            };
          }
          else if(item.uploadTask){
            return {
              data: {
                id: item.displayId + "_" + item.uploadTask.goTo,
                source: item.displayId,
                target: item.uploadTask.goTo
              }
            };
          }
          else if (item.videoCaptureTask)
            return {
              data: {
                id: item.displayId + "_" + item.videoCaptureTask.goTo,
                source: item.displayId,
                target: item.videoCaptureTask.goTo
              }
            };
          else if (item.textNavigationTask)
            return {
              data: {
                id: item.displayId + "_" + item.textNavigationTask.goTo,
                source: item.displayId,
                target: item.textNavigationTask.goTo
              }
            };
          else if(item.podcastTask){
            return {
              data: {
                id: item.displayId + "_" + item.podcastTask.goTo,
                source: item.displayId,
                target: item.podcastTask.goTo
              }
            };
          }
          else if(item.videoQuizTask){
            return {
              data: {
                id: item.displayId + "_" + item.videoQuizTask.goTo,
                source: item.displayId,
                target: item.videoQuizTask.goTo
              }
            };
          }
        });

        // For Dialog Task with multiple options
        var multipleLinks = this.story.tasks.filter(function(item) {
          if(item.dialogTask)
            return !item.dialogTask.goTo && item.dialogTask.options && item.dialogTask.options.length > 0;
        });

        for (var i = 0; i < multipleLinks.length; i++) {
          for (var j = 0; j < multipleLinks[i].dialogTask.options.length; j++) {
            getEdges.push({
              data: {
                id: multipleLinks[i].dialogTask.displayId + "_" + multipleLinks[i].dialogTask.options[j].goTo,
                source: multipleLinks[i].displayId,
                target: multipleLinks[i].dialogTask.options[j].goTo
              }
            });
          }
        }

        // For Navigation Task with multiple location options
        var multipleLinks = this.story.tasks.filter(function(item) {
          if(item.navigationTask){
            return item.navigationTask.locationOptions && item.navigationTask.locationOptions.length > 0;
          }
        });

        for (var i = 0; i < multipleLinks.length; i++) {
          for (var j = 0; j < multipleLinks[i].navigationTask.locationOptions.length; j++) {
            if(multipleLinks[i].navigationTask.locationOptions[j].goTo && multipleLinks[i].navigationTask.locationOptions[j].moduleId == this.moduleId){
              getEdges.push({
                data: {
                  id: multipleLinks[i].displayId + "_" + multipleLinks[i].navigationTask.locationOptions[j].goTo,
                  source: multipleLinks[i].displayId,
                  target: multipleLinks[i].navigationTask.locationOptions[j].goTo
                }
              });
            }
          }
        }

        // For iSpring Quiz Tasks with pass / fail
        var iSpringQuizTasks = this.story.tasks.filter(function(item) {
          return item.iSpringQuizTask;
        });

        for (var i = 0; i < iSpringQuizTasks.length; i++) {
          if((iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto || iSpringQuizTasks[i].iSpringQuizTask.failTaskGoto) && (iSpringQuizTasks[i].iSpringQuizTask.failTaskGoto != iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto)) {
            if(iSpringQuizTasks[i].iSpringQuizTask.failTaskGoto) {
              getEdges.push({
                data: {
                  id: iSpringQuizTasks[i].displayId +  "_" + iSpringQuizTasks[i].iSpringQuizTask.failTaskGoto,
                  source: iSpringQuizTasks[i].displayId,
                  target: iSpringQuizTasks[i].iSpringQuizTask.failTaskGoto
                }
              });
            }

            if(iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto) {
              getEdges.push({
                data: {
                  id: iSpringQuizTasks[i].displayId +  "_" + iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto,
                  source: iSpringQuizTasks[i].displayId,
                  target: iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto
                }
              });
            }
          }
          else{
            if(iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto) {
              getEdges.push({
                data: {
                  id: iSpringQuizTasks[i].displayId +  "_" + iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto,
                  source: iSpringQuizTasks[i].displayId,
                  target: iSpringQuizTasks[i].iSpringQuizTask.passTaskGoto
                }
              });
            }
          }
        }

        // For Quiz Tasks with pass / fail
        var quizTasks = this.story.tasks.filter(function(item) {
          return item.quizTask;
        });

        for (var i = 0; i < quizTasks.length; i++) {
          
          if(quizTasks[i].quizTask.failTaskGoto != quizTasks[i].quizTask.passTaskGoto){
            getEdges.push({
              data: {
                id: quizTasks[i].displayId +  "_" + quizTasks[i].quizTask.failTaskGoto,
                source: quizTasks[i].displayId,
                target: quizTasks[i].quizTask.failTaskGoto
              }
            });
          }

          if(quizTasks[i].quizTask.passTaskGoto){
            getEdges.push({
              data: {
                id: quizTasks[i].displayId +  "_" + quizTasks[i].quizTask.passTaskGoto,
                source: quizTasks[i].displayId,
                target: quizTasks[i].quizTask.passTaskGoto
              }
            });
          }
        }

        // For Text Navigation Task with multiple options
        var multipleLinks = this.story.tasks.filter(function(item) {
          if(item.textNavigationTask)
            return !item.textNavigationTask.goTo && item.textNavigationTask.options && item.textNavigationTask.options.length > 0;
        });

        for (var i = 0; i < multipleLinks.length; i++) {
          for (var j = 0; j < multipleLinks[i].textNavigationTask.options.length; j++) {
            getEdges.push({
              data: {
                id: multipleLinks[i].textNavigationTask.displayId + "_" + multipleLinks[i].textNavigationTask.options[j].goTo,
                source: multipleLinks[i].displayId,
                target: multipleLinks[i].textNavigationTask.options[j].goTo
              }
            });
          }
        }

        return {
          nodes: getNodes,
          edges: getEdges
        };
      } else {
          return {
            nodes: [],
            edges: []
          };
      }
    },
    configure() {
      var self = this;
      self.tasks = self.story.tasks.map((item) => {return {label: item.displayId + " : " + item.name, value: item.id} });
      var moduleId = null;
      var checkForKeys = Object.keys(self.$route.query);

      if(self.selectedData && checkForKeys == 0) {
        moduleId = self.selectedData.selectedTopic.id;
      }
      else {
        moduleId = localStorage.getItem("currentModule");
      }

      self.getBuilderModule(moduleId);

    },
    getBuilderModule(moduleId){
      var self = this;
      self.showLoadingOnElement("builderpage", 1, "material");

      var onSuccess = function (response) {
        self.moduleData = response.data;
        if(self.moduleData.startTaskId){
          self.startTaskDropdown = self.tasks.filter(function(item){return item.value == self.moduleData.startTaskId;})[0];
        }
        if (self.moduleData.endTaskId) {
          self.endTaskDropdown = self.tasks.filter(function (item) { return item.value == self.moduleData.endTaskId; })[0];
        }
        if(self.moduleData.milestones.length > 0) {
          self.moduleData.milestones.forEach(function(item){ 
            item.milestoneTaskDropdown = self.tasks.filter(function(task){return task.value == item.taskId;})[0];
          })
        }
        self.configurePopupActive = true;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.builderpage.$el);
      };

      self.$ajaxGet(self, "module/GetBuilderModule/" + moduleId, onSuccess, onFinally);
    },
    addMilestones() {
      var self = this;
      self.moduleData.milestones.push({
        id: 0,
        moduleId: self.moduleData.id,
        taskId: "",
        days: "",
        coins: 0
      });
    },
    deleteMilestone(index) {
      this.moduleData.milestones.splice(index,1)
    },
    saveModule() {
      var self = this;
      self.$validator.validateAll().then(result => {

        if (result) {
          self.showLoadingOnElement("saveModuleButton", 0.65, "material");
          self.moduleData.startTaskId = self.startTaskDropdown ? parseInt(self.startTaskDropdown.value) : null;
          self.moduleData.endTaskId = self.endTaskDropdown ? parseInt(self.endTaskDropdown.value) : null;
          self.moduleData.milestones.forEach(function(item){ 
            item.taskId = item.milestoneTaskDropdown ? parseInt(item.milestoneTaskDropdown.value) : null;
          })
          
          var onSuccess = response => {
            self.moduleData.id = response.data;
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Module Settings Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
            self.configurePopupActive = false;
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.saveModuleButton.$el);
          };
          
          self.$ajaxPost(self, "Module/AddEditModule", self.moduleData, onSuccess, onFinally);
        }else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    completeModule() {
      var self = this;
      self.showLoadingOnElement("completeModuleButton", 0.45, "material");

      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.moduleData.startTaskId = self.startTaskDropdown ? parseInt(self.startTaskDropdown.value) : null;
          self.moduleData.endTaskId = self.endTaskDropdown ? parseInt(self.endTaskDropdown.value) : null;
          self.moduleData.milestones.forEach(function(item){ 
            item.taskId = item.milestoneTaskDropdown ? parseInt(item.milestoneTaskDropdown.value) : null;
          })
          
          var onSaveSuccess = response => {
            self.moduleData.id = response.data;

            var onSuccess = response => {
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Module Settings Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
              self.configurePopupActive = false;
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.completeModuleButton.$el);
            };
            
            self.$ajaxGet(self, "module/CompleteModule/" + self.moduleData.id, onSuccess, onFinally);
          };
          
          var onSaveFinally = function () {
            self.$vs.loading.close(self.$refs.completeModuleButton.$el);
          };
          
          self.$ajaxPost(self, "Module/AddEditModule", self.moduleData, onSaveSuccess, onSaveFinally);
        }else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    gettaskClassificationTypes(){
      var self = this;
      var onSuccess = response => {       
        self.taskClassificationTypes = response.data.map(function(item) {return {value: item.value,label: item.text}})
      };
      self.$ajaxGet(self, "Course/gettaskClassificationTypes", onSuccess);
    },
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.showLoadingOnElement("cytoscape", 1, "corners");
    this.loadData();
    window.addEventListener('resize', () => {
        this.cyUpdate();
    });

    if(this.$route.path == "/digi/builder")
      this.$store.dispatch("updateTheme", "dark");

    if(localStorage.getItem("selectedData")) {
      this.selectedData = JSON.parse(localStorage.getItem("selectedData"));
    }
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  }
};
</script>

<style lang="scss" scoped>
.numberinput{
  background: transparent;
  float: left;
}

div.router-view {
  padding-bottom: 0 !important;
}

#content-area .content-wrapper {
  min-height: calc(100vh - 5.6rem) !important;
}

#holder {
  text-align: start !important;
  width: 100%;
  height: calc(100vw * 0.26);
  /* height: 395px; */
}

@media screen and (min-width: 1900px) {
  #holder {
    width: 100%;
    height: calc(100vw * 0.345) !important;
    /* height: 740px !important; */
  }
}

#container:fullscreen {
  background-color: rgba(255, 255, 255, 0);
}
#container:-webkit-full-screen {
  background-color: rgba(255, 255, 255, 0);
}
#container:-moz-full-screen {
  background-color: rgba(255, 255, 255, 0);
}
</style>

<style lang="scss">
.popup_class .vs-popup {
  // background: rgb(65, 71, 94) !important;
  // color: rgb(202, 202, 202) !important;
  // > header.vs-popup--header {
  //   background: rgb(38, 45, 74) !important;

  //   > div.vs-popup--title > h3 {
  //     color: rgb(255, 255, 255) !important;
  //   }
  // }

  .vs-popup--content {
    height: inherit !important;
  }
}

#milestones-row{
  align-items: flex-end;
}

.vs-textarea {
  border: 1px solid #c2c6dc !important;
}
</style>
